import { isWistiaVideoLink } from "@my-scoot/exly-react-component-lib/build/esm/features/Common/modules/VideoUploader/utils/VideoUploader.utils";
import { getWistiaHashIdFromLink } from "features/MediaLibrary/utils/MediaLibrary.utils";
import React from "react";
import { getS3SignedUrl } from "utils/Utils";
import { is_empty } from "utils/validations";
import { useExternalScript } from "../../../utils/hooks";
import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";
import { getS3BucketName } from "@my-scoot/exly-react-component-lib/build/esm/features/Common/modules/S3/utils/S3.utils.js";

const WistiaVideo = ({ url }) => {
  const wistiaKey = getWistiaHashIdFromLink(url);
  useExternalScript(`https://fast.wistia.com/embed/medias/${wistiaKey}.jsonp`);
  useExternalScript("https://fast.wistia.com/assets/external/E-v1.js");

  // Don't remove these inline style tags. The third-party UI only renders fine with inline components
  return (
    <div
      className="wistia_responsive_padding"
      style={{
        position: "relative",
        width: "500px",
        maxWidth: "80vw",
      }}
    >
      <div
        className="wistia_responsive_wrapper"
        style={{
          height: "100%",
          left: "0",
          top: "0",
          width: "100%",
        }}
      >
        <div
          className={`wistia_embed wistia_async_${wistiaKey} videoFoam=true fitStrategy=fill`}
          style={{
            height: "100%",
            position: "relative",
            width: "100%",
          }}
        >
          <div
            className="wistia_swatch"
            // @todo: use class
            style={{
              height: "100%",
              left: "0",
              opacity: "0",
              overflow: "hidden",
              position: "absolute",
              top: "0",
              transition: "opacity 200ms",
              width: "100%",
            }}
          >
            <ExlyImage
              src={`https://fast.wistia.com/embed/medias/${wistiaKey}/swatch`}
              style={{
                filter: "blur(5px)",
                height: "100%",
                objectFit: " contain",
                width: "100%",
              }}
              alt=""
              aria-hidden="true"
              onLoad={(e) => {
                if (e?.target?.parentNode?.style)
                  e.target.parentNode.style.opacity = 1;
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default function VideoComp({ url, isZoomRecording, originListing }) {
  const [errored, setErrored] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [preview_url, set_preview_url] = React.useState(null);

  const isWistia = isWistiaVideoLink(url);

  React.useEffect(() => {
    (async () => {
      if (isWistia) return;

      const video = document.createElement("video");
      video.onerror = () => {
        setLoading(false);
        setErrored(true);
      };
      video.loading = () => {
        setLoading(true);
      };
      video.onload = () => {
        setLoading(false);
      };
      const bucket = getS3BucketName(url);
      if (!is_empty(originListing) || isZoomRecording) {
        let key = url.split("amazonaws.com/")[1];
        let creds = {
          accessKeyId: `${process.env.REACT_APP_EXLY_S3_ACCESS_KEY_ID}`,
          secretAccessKey: `${process.env.REACT_APP_EXLY_S3_SECRET_ACCESS_KEY}`,
          region: `${process.env.REACT_APP_S3_REGION}`,
        };
        let signed_url = await getS3SignedUrl(
          key,
          bucket ?? `${process.env.REACT_APP_EXLY_S3_BUCKET}`,
          creds
        );
        video.src = signed_url;
        set_preview_url(signed_url);
      } else {
        video.src = url;
        set_preview_url(url);
      }
    })();
  }, []);

  return (
    <div>
      <WistiaVideo url={url} />
      {!isWistia && loading && <div>Loading...</div>}
      {loading && <div>Loading...</div>}
      {!isWistia && !loading && (
        <span>
          {errored && (
            <div className="text-danger">
              Video player cannot be shown for added link, please check the link
              once
            </div>
          )}
          {!errored && !is_empty(preview_url) && (
            <video width="600" height="340" controls>
              <source src={preview_url} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
        </span>
      )}
    </div>
  );
}
